<template>
    <div class="compare">
        <v-row class="d-md-flex align-center">
            <v-col><h1>{{ $t('compare') }}</h1></v-col>
            <v-col class="filter-box d-flex justify-end" cols="12" md="4">
                <v-btn class="btn-two mr-3" color="#08a657" height="56px" depressed
                       @click.stop="toggleFiltre()"
                >
                    <v-icon medium>mdi-filter-outline</v-icon>
                    {{ $t('filter') }}
                </v-btn>

            </v-col>

        </v-row>
        <v-row>
            <v-col class="py-0">
                <v-chip
                        v-if="compareDate.dateTimeBegin1 && compareDate.dateTimeEnd1"
                        class="ma-1"
                        close
                        @click:close="removeFilterDate(1)"
                        small
                >
                    <strong>{{ $t('dash.period1') }}</strong>: {{ compareDate.dateTimeBegin1}} / {{ compareDate.dateTimeEnd1 }}
                </v-chip>
                <v-chip
                        v-if="compareDate.dateTimeBegin2 && compareDate.dateTimeEnd2"
                        class="ma-1"
                        close
                        @click:close="removeFilterDate(2)"
                        small
                >
                    <strong>{{ $t('dash.period2') }}</strong>: {{ compareDate.dateTimeBegin2}} / {{ compareDate.dateTimeEnd2 }}
                </v-chip>
                <v-chip
                        v-if="organizationId"
                        class="ma-1"
                        close
                        @click:close="removeFilterOrganisation()"
                        small
                >
                    <strong>{{ $t('organizations') }}</strong>: {{organisationName}}
                </v-chip>
                <v-chip
                        v-if="(compareDate.dateTimeBegin1 && compareDate.dateTimeEnd1) || (compareDate.dateTimeBegin2 && compareDate.dateTimeEnd2) || organizationId"
                        class="ma-1"
                        close
                        @click:close="removeFilterAll()"
                        small
                        outlined
                >
                    <strong>{{ $t('clear') }}</strong>
                </v-chip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-expand-transition>
                    <div class="transition-display brd-top-vone" v-show="showFilter">
                        <v-card>
                            <v-card-text>
                                <CompareFilter
                                        :apply-filter="applyFilter"
                                        :all-organisations="allOrganizations"
                                        :compare-date="compareDate"
                                        :organization-id="organizationId"
                                />
                            </v-card-text>
                        </v-card>
                    </div>
                </v-expand-transition>
            </v-col>
        </v-row>
        <CompareResult :fields="fields" :compare-date="compareDate"/>
    </div>
</template>

<script>
    import config from '../../config'
    import Axios from 'axios'

    import CompareFilter from "./CompareFilter";
    import CompareResult from "./CompareResult";

    const qs = require('querystring')

    export default {
        components: {CompareFilter, CompareResult},
        name: "Dashboard",
        props: [],
        data() {
            return {
                showFilter: true,
                allOrganizations: [],
                compareDate: {
                    dateTimeBegin1: '',
                    dateTimeEnd1: '',
                    dateTimeBegin2: '',
                    dateTimeEnd2: '',
                },
                organizationId: '',
                fields: [
                    {id: 0, t: 'dash.cmrs', name: 'count', val: ''},
                    {id: 1, t: 'dash.assigned', name: 'assignedCount', val: ''},
                    {id: 2, t: 'dash.signedByDriver', name: 'signedByDriverCount', val: ''},
                    {id: 3, t: 'dash.signedByReceiver', name: 'signedByReceiverCount', val: ''},
                    {id: 4, t: 'dash.latePickup', name: 'latePickupCount', val: ''},
                    {id: 5, t: 'dash.totalTimeLatePickup', name: 'latePickupTime', val: ''},
                    {id: 6, t: 'dash.lateDelivery', name: 'lateDeliveryCount', val: ''},
                    {id: 7, t: 'dash.totalTimeLateDelivery', name: 'lateDeliveryTime', val: ''},
                    {id: 8, t: 'dash.remarksSender', name: 'senderRemarksCount', val: ''},
                    {id: 9, t: 'dash.remarksDriver', name: 'driverRemarksCount', val: ''},
                    {id: 10, t: 'dash.remarksReceiver', name: 'receiverRemarksCount', val: ''},
                    {id: 11, t: 'dash.activeDrivers', name: 'activeDriversCount', val: ''},
                    {id: 12, t: 'dash.activeSigners', name: 'activeSignersCount', val: ''},
                ],
            }
        },
        computed: {
            organisationName() {
                return this.allOrganizations.filter( el => el.id === this.organizationId)[0].name
            }
        },
        methods: {
            applyFilter(compareDate = {}, organisation = '') {
                this.compareDate = compareDate;
                this.organizationId = organisation;
                this.getCompare();
                this.toggleFiltre();
            },
            getAllOrganizatios() {
                let payload = Object.assign({}, this.payload);
                payload.Limit = 9999999;
                Axios.post(config.apiBaseUrl + 'api/organization/list', qs.stringify(payload), {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then(response => {
                        if (response.status === 200) {
                            this.allOrganizations = response.data.data
                        }
                    })
                    .catch(error => {
                        /* eslint-disable */
                        console.log(error)
                    })
            },
            getInfo(begin, end) {
                return Axios.get(config.apiBaseUrl + `api/cmr/dashboard?begin=${begin}&end=${end}&organizationId=${this.organizationId}`, {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                })
                    .then(({status, data}) => {
                        if (status === 200) {
                            return data
                        }
                    })
                    .catch(error => {
                        /* eslint-disable */
                        console.log(error)
                    })
            },
            toggleFiltre() {
                this.showFilter = !this.showFilter;
            },

            setCurrentPeriods() {
                const date = new Date();
                let y = date.getFullYear(),
                    m = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1,
                    d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                this.compareDate.dateTimeBegin2 = `${y}-${m}-01`;
                this.compareDate.dateTimeEnd2 = `${y}-${m}-${d}`;

                if (m === '01') {
                    y--;
                    m = 12;
                } else {
                    m = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth();
                }

                const daysInMonth = 33 - new Date(y, m - 1, 33).getDate();
                this.compareDate.dateTimeBegin1 = `${y}-${m}-01`;
                this.compareDate.dateTimeEnd1 = `${y}-${m}-${daysInMonth}`;

            },

            async getCompare() {
                const {dateTimeBegin1, dateTimeEnd1, dateTimeBegin2, dateTimeEnd2} = this.compareDate;
                const data1 = this.getInfo(dateTimeBegin1, dateTimeEnd1);
                const data2 = this.getInfo(dateTimeBegin2, dateTimeEnd2);

                Promise.all([data1, data2])
                    .then(([data1, data2]) => {
                        this.fields = this.fields.map(el => {
                            el.val = [data1[el.name], data2[el.name]]
                            return el;
                        })
                    })
                    .catch(err => {
                        console.log(err);
                    })

            },
            removeFilterDate(period) {
                if(period === 1) {
                    this.compareDate = {
                        dateTimeBegin1: '',
                        dateTimeEnd1: '',
                        dateTimeBegin2: this.compareDate.dateTimeBegin2,
                        dateTimeEnd2: this.compareDate.dateTimeEnd2,
                    };
                }
                if(period === 2) {
                    this.compareDate = {
                        dateTimeBegin1: this.compareDate.dateTimeBegin1,
                        dateTimeEnd1: this.compareDate.dateTimeEnd1,
                        dateTimeBegin2: '',
                        dateTimeEnd2: '',
                    };
                }
                this.getCompare();
            },
            removeFilterOrganisation() {
                this.organizationId = '';
                this.getCompare();
            },
            removeFilterAll() {
                this.compareDate = {
                    dateTimeBegin1: '',
                    dateTimeEnd1: '',
                    dateTimeBegin2: '',
                    dateTimeEnd2: '',
                };
                this.organizationId = '';
                this.getCompare();
            }

            //------------ end methods
        },
        created() {
            this.setCurrentPeriods();
            this.getAllOrganizatios();
            this.getCompare();
        },

    }
</script>